export default {
  completeProfile: {
    intro: {
      title: "Richten wir alles ein",
      subtitle: "Ein paar schnelle Berechtigungen helfen uns, relevantere Quoten anzuzeigen, rechtzeitige Updates zu senden und dein Gesamterlebnis zu verbessern.",
    },
    tracking: {
      title: "Hilf dabei, Linemate kostenlos zu halten",
      subtitle: "Wir bitten um deine Erlaubnis, einige Aktivitäten auf diesem Gerät zu verfolgen. Wenn du auf dem nächsten Bildschirm „Tracking erlauben“ auswählst, hilfst du uns dabei:",
      buttonSubtext: "Du kannst diese Option später in den Einstellungen ändern",
      cards: {
        support: {
          title: "Linemate unterstützen",
          body: "Das hilft uns, die App und die Funktionen, die du am meisten nutzt, weiter zu verbessern.",
        },
        relevantContent: {
          title: "Relevantere Inhalte sehen",
          body: "Wir nutzen diese Daten, um Angebote, Trends und Anzeigen anzuzeigen, die für dich relevanter sind.",
        },
      },
    },
  },
};
